import React from 'react';
import PropTypes from 'prop-types';
import { openTab } from '../../../src/utils/openTab';
import FSFlatButton from '../../../src/components/lib/FSFlatButton';

const BaseCalloutSection = (props) => {
  const {
    reportButtonPress,
    buttonUrl,
    imgUrl,
    imgAlt,
    title,
    subtitle,
    buttonTitle,
    buttonPressString,
    buttonColor = '#FAA718',
  } = props;

  return (
    <div className='homepage-base-section'>
      <div className='homepage-base-section-container'>
        <div className='homepage-base-section-left-col'>
          <div
            className='homepage-base-section-badge'
            style={{ backgroundImage: `url(${imgUrl})` }}
            alt={imgAlt}
          />
        </div>
        <div className='homepage-base-section-right-col'>
          <div className='homepage-base-text-container'>
            <h3>{title}</h3>
            <h4>{subtitle}</h4>
          </div>
          <div className='homepage-base-button-container'>
            <FSFlatButton
              href={buttonUrl}
              backgroundColor={buttonColor}
              label={buttonTitle}
              onClick={(e) => {
                e.preventDefault();
                reportButtonPress(buttonPressString);
                openTab(buttonUrl);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

BaseCalloutSection.propTypes = {
  reportButtonPress: PropTypes.func,
  buttonUrl: PropTypes.string,
  imgUrl: PropTypes.string,
  imgAlt: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  buttonTitle: PropTypes.string,
  buttonPressString: PropTypes.string,
  buttonColor: PropTypes.string,
};

export default BaseCalloutSection;



// WEBPACK FOOTER //
// ./modules/Homepage/components/BaseCalloutSection.js